import WebServiceRequest from "../../Api/WebServiceRequest";

class MediaCreateFileRequest extends WebServiceRequest {
  constructor(context) {
    super(context);
    super.setTag("Gallery/Upload");
  }
  setParams(data) {
    super.setRequestParamDataObj(data);
  }
}
export default MediaCreateFileRequest;
